var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDubai(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 616,
    height: 411,
    viewBox: "0 0 616 411",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_398_12737",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 616,
    height: 411
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 616,
    height: 411,
    rx: 16,
    fill: "#0B1D4E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_398_12737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.819 263.271H384.027V261.375H357.706V263.271H353.914V261.375H337.297L351.619 268.011L366.486 281.853L372.827 294.157L374.176 307.486V323.378L388.711 325.941V341.321H392.503V323.378V292.156L404.436 284.461V261.375H387.819V263.271ZM400.644 282.398L388.711 290.093V323.378H375.714L375.201 299.796L366.999 280.315L355.72 271.6L342.391 265.167H400.644V282.398Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.442 274.205C392.442 272.365 390.936 270.859 389.096 270.859C387.256 270.859 385.75 272.365 385.75 274.205V281.454H392.386V274.205H392.442Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.262 274.205C373.262 272.365 371.756 270.859 369.916 270.859C368.076 270.859 366.57 272.365 366.57 274.205V281.454H373.206V274.205H373.262Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.71 202.379L348.564 196.58V183.698H393.175V196.133L384.03 202.044V261.433H387.822V204.052L396.911 198.197V179.906H387.487V181.802H383.695V179.906H357.375V181.802H353.583V179.906H344.828V198.643L353.918 204.442V261.433H357.71V202.379Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.815 261.438H384.023V263.333H387.815V261.438Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.706 261.438H353.914V263.333H357.706V261.438Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.759 187.945C355.365 187.945 354.25 189.061 354.25 190.455V195.864H359.213V190.455C359.213 189.061 358.098 187.945 356.759 187.945Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.597 190.455C386.597 189.061 385.482 187.945 384.087 187.945C382.693 187.945 381.578 189.061 381.578 190.455V195.864H386.541V190.455H386.597Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.806 187.945C368.412 187.945 367.297 189.061 367.297 190.455V195.864H372.26V190.455C372.26 189.061 371.145 187.945 369.806 187.945Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.375 152.591L348.229 146.736V133.854H392.785V146.345L383.695 152.201V179.915H387.487V154.264L396.576 148.353V130.062H383.137V131.958H379.346V130.062H358.601V131.958H354.865V130.062H344.438V148.799L353.583 154.654V179.915H357.375V152.591Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.487 179.906H383.695V181.802H387.487V179.906Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.37 179.906H353.578V181.802H357.37V179.906Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.369 138.141C354.975 138.141 353.859 139.256 353.859 140.65V146.059H358.822V140.65C358.878 139.256 357.763 138.141 356.369 138.141Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.206 140.595C386.206 139.201 385.091 138.086 383.697 138.086C382.303 138.086 381.188 139.201 381.188 140.595V146.004H386.15V140.595H386.206Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.423 138.141C368.029 138.141 366.914 139.256 366.914 140.65V146.059H371.877V140.65C371.933 139.256 370.818 138.141 369.423 138.141Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.604 93.1973C358.604 91.3571 362.564 88.7362 368.976 88.7362C375.389 88.7362 379.348 91.3013 379.348 93.1973V130.057H383.14V93.1973C383.14 88.5131 377.062 85 368.976 85C360.891 85 354.812 88.5131 354.812 93.1973V130.057H358.604V93.1973Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.644 130.062H354.852V131.958H358.644V130.062Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.136 130.062H379.344V131.958H383.136V130.062Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.81 372.012H398.743V365.432H405.937C407.61 365.432 409.004 364.038 409.004 362.365C409.004 360.692 407.61 359.298 405.937 359.298H394.003V343.74C395.676 343.74 397.07 342.346 397.07 340.673C397.07 339 395.676 337.606 394.003 337.606H387.591V327.178C388.873 326.788 389.765 325.617 389.765 324.223C389.765 322.55 388.371 321.156 386.698 321.156H377.553V310.672C378.78 310.282 379.672 309.111 379.672 307.772C379.672 306.378 378.724 305.207 377.442 304.817C376.438 289.705 367.906 275.876 354.634 268.236L335.229 257.083C335.006 256.972 334.838 256.86 334.615 256.805V254.128C334.615 250.392 331.604 247.381 327.868 247.381V222.677C327.868 221.618 327.031 220.781 325.972 220.781C324.912 220.781 324.076 221.618 324.076 222.677V247.381C320.674 247.715 317.998 250.615 317.998 254.128V257.028C317.942 257.083 317.886 257.083 317.83 257.139L298.425 268.292C285.209 275.876 276.677 289.649 275.617 304.705H273.219C271.547 304.705 270.152 306.1 270.152 307.772C270.152 308.944 270.822 310.003 271.825 310.505V321.156H265.078C263.405 321.156 262.011 322.55 262.011 324.223C262.011 325.617 262.959 326.844 264.297 327.178V337.606H257.661C255.989 337.606 254.594 339 254.594 340.673C254.594 342.346 255.989 343.74 257.661 343.74H258.163V359.298H246.62C244.947 359.298 243.553 360.692 243.553 362.365C243.553 364.038 244.947 365.432 246.62 365.432H251.416V373.016C244.167 373.295 238.367 379.261 238.367 386.567V409.151H415.305V385.563C415.361 378.09 409.283 372.012 401.81 372.012ZM324.857 251.172H327.979C329.652 251.172 330.991 252.511 330.991 254.184V256.303H321.901V254.184C321.845 252.511 323.184 251.172 324.857 251.172ZM300.376 271.526L319.782 260.373C320.228 260.095 320.73 259.983 321.288 259.983H331.939C332.44 259.983 332.998 260.095 333.444 260.373L352.85 271.526C364.895 278.441 372.702 290.932 373.705 304.705H279.465C280.469 290.988 288.276 278.441 300.376 271.526ZM275.673 310.839H373.817V321.156H275.673V310.839ZM268.089 327.29H383.799V337.606H268.089V327.29ZM262.011 343.74H390.323V359.298H262.011V343.74ZM411.569 405.359H242.159V386.567C242.159 381.157 246.564 376.752 251.974 376.752H255.208V365.432H394.951V375.748H401.755C407.164 375.748 411.569 380.154 411.569 385.563V405.359Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.605 395.429C274.161 395.429 276.233 393.356 276.233 390.8C276.233 388.244 274.161 386.172 271.605 386.172C269.049 386.172 266.977 388.244 266.977 390.8C266.977 393.356 269.049 395.429 271.605 395.429Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.081 379.538C284.638 379.538 286.71 377.466 286.71 374.91C286.71 372.353 284.638 370.281 282.081 370.281C279.525 370.281 277.453 372.353 277.453 374.91C277.453 377.466 279.525 379.538 282.081 379.538Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.734 392.049C297.407 389.584 295.953 387.039 293.487 386.366C291.021 385.693 288.477 387.147 287.804 389.613C287.131 392.079 288.585 394.624 291.051 395.296C293.517 395.969 296.061 394.515 296.734 392.049Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.441 395.429C362.997 395.429 365.069 393.356 365.069 390.8C365.069 388.244 362.997 386.172 360.441 386.172C357.885 386.172 355.812 388.244 355.812 390.8C355.812 393.356 357.885 395.429 360.441 395.429Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.863 379.538C373.419 379.538 375.491 377.466 375.491 374.91C375.491 372.353 373.419 370.281 370.863 370.281C368.307 370.281 366.234 372.353 366.234 374.91C366.234 377.466 368.307 379.538 370.863 379.538Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.508 392.065C386.18 389.599 384.727 387.055 382.261 386.382C379.795 385.709 377.25 387.163 376.578 389.629C375.905 392.095 377.358 394.639 379.824 395.312C382.29 395.985 384.835 394.531 385.508 392.065Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.189 345.297C279.126 345.297 277.453 346.97 277.453 349.033V357.175H284.925V349.033C284.925 346.97 283.253 345.297 281.189 345.297Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.103 345.297C301.04 345.297 299.367 346.97 299.367 349.033V357.175H306.84V349.033C306.84 346.97 305.167 345.297 303.103 345.297Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.025 345.297C322.962 345.297 321.289 346.97 321.289 349.033V357.175H328.761V349.033C328.761 346.97 327.088 345.297 325.025 345.297Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.947 345.297C344.884 345.297 343.211 346.97 343.211 349.033V357.175H350.683V349.033C350.683 346.97 349.01 345.297 346.947 345.297Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.846 345.297C366.782 345.297 365.109 346.97 365.109 349.033V357.175H372.582V349.033C372.582 346.97 370.909 345.297 368.846 345.297Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.178 329.852C277.119 329.852 276.227 330.744 276.227 331.803V336.097H280.186V331.803C280.186 330.744 279.294 329.852 278.178 329.852Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.038 329.852C282.978 329.852 282.086 330.744 282.086 331.803V336.097H286.045V331.803C285.989 330.744 285.153 329.852 284.038 329.852Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.202 329.852C299.142 329.852 298.25 330.744 298.25 331.803V336.097H302.209V331.803C302.153 330.744 301.261 329.852 300.202 329.852Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.069 329.852C305.009 329.852 304.117 330.744 304.117 331.803V336.097H308.076V331.803C308.021 330.744 307.128 329.852 306.069 329.852Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.233 329.852C321.173 329.852 320.281 330.744 320.281 331.803V336.097H324.24V331.803C324.185 330.744 323.292 329.852 322.233 329.852Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.038 329.852C326.978 329.852 326.086 330.744 326.086 331.803V336.097H330.045V331.803C330.045 330.744 329.153 329.852 328.038 329.852Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.202 329.852C343.142 329.852 342.25 330.744 342.25 331.803V336.097H346.209V331.803C346.153 330.744 345.317 329.852 344.202 329.852Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.061 329.852C349.002 329.852 348.109 330.744 348.109 331.803V336.097H352.069V331.803C352.013 330.744 351.121 329.852 350.061 329.852Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.233 329.852C365.173 329.852 364.281 330.744 364.281 331.803V336.097H368.24V331.803C368.185 330.744 367.292 329.852 366.233 329.852Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.077 329.852C371.017 329.852 370.125 330.744 370.125 331.803V336.097H374.084V331.803C374.028 330.744 373.136 329.852 372.077 329.852Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.732 405.367H186.896C185.836 405.367 185 406.204 185 407.263C185 408.323 185.836 409.159 186.896 409.159H455.732C456.792 409.159 457.628 408.323 457.628 407.263C457.628 406.204 456.736 405.367 455.732 405.367Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.386 289.647L237.739 286.19V274.201H231.271V268.903C232.665 268.791 233.947 268.122 234.895 267.007C235.955 265.78 236.401 264.163 236.122 262.602L224.858 194.235C224.579 192.618 223.241 191.503 221.624 191.447C220.006 191.392 218.612 192.507 218.334 194.124L205.173 262.434C204.839 264.052 205.285 265.669 206.344 266.896C207.404 268.122 208.91 268.847 210.527 268.847H210.806V274.145H205.452V286.413L210.861 289.87V322.325H201.047V337.492L208.129 342.009V409.148H235.23V341.73L242.256 337.158V322.325H232.386V289.647ZM209.244 264.553C209.077 264.33 208.742 263.828 208.91 263.159L221.568 197.358L232.386 263.215C232.498 263.884 232.219 264.33 231.996 264.553C231.828 264.776 231.382 265.111 230.713 265.111H210.471C209.857 265.111 209.411 264.776 209.244 264.553ZM214.542 268.903H227.479V274.201H214.542V268.903ZM209.188 284.405V277.992H233.947V284.182L228.594 287.64V322.38H214.597V287.863L209.188 284.405ZM238.408 335.094L231.382 339.667V405.357H211.865V339.946L204.783 335.429V326.116H238.408V335.094Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.646 330.639C212.646 329.58 211.753 328.688 210.694 328.688C209.634 328.688 208.742 329.58 208.742 330.639V334.933H212.701V330.639H212.646Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.341 330.639C234.341 329.58 233.449 328.688 232.389 328.688C231.33 328.688 230.438 329.58 230.438 330.639V334.933H234.397V330.639H234.341Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.013 330.639C223.013 329.58 222.121 328.688 221.061 328.688C220.002 328.688 219.109 329.58 219.109 330.639V334.933H223.069V330.639H223.013Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.704 281.169C214.704 280.332 214.035 279.719 213.255 279.719C212.418 279.719 211.805 280.388 211.805 281.169V284.347H214.76V281.169H214.704Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.884 281.169C230.884 280.332 230.215 279.719 229.434 279.719C228.598 279.719 227.984 280.388 227.984 281.169V284.347H230.94V281.169H230.884Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.47 281.169C222.47 280.332 221.801 279.719 221.02 279.719C220.239 279.719 219.57 280.388 219.57 281.169V284.347H222.526V281.169H222.47Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.8 347.806C224.8 345.743 223.128 344.07 221.064 344.07C219.001 344.07 217.328 345.743 217.328 347.806V355.948H224.8V347.806Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.965 279.734C220.129 279.734 219.516 280.404 219.516 281.184V284.363H222.471V281.184C222.471 280.404 221.802 279.734 220.965 279.734Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.434 279.734C228.598 279.734 227.984 280.404 227.984 281.184V284.363H230.94V281.184C230.884 280.404 230.215 279.734 229.434 279.734Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.27 279.734C212.434 279.734 211.82 280.404 211.82 281.184V284.363H214.776V281.184C214.72 280.404 214.051 279.734 213.27 279.734Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.286 330.639C423.286 329.58 422.394 328.688 421.335 328.688C420.275 328.688 419.383 329.58 419.383 330.639V334.933H423.342V330.639H423.286Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.919 330.639C444.919 329.58 444.027 328.688 442.967 328.688C441.908 328.688 441.016 329.58 441.016 330.639V334.933H444.975V330.639H444.919Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.591 330.639C433.591 329.58 432.699 328.688 431.639 328.688C430.58 328.688 429.688 329.58 429.688 330.639V334.933H433.647V330.639H433.591Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.965 289.653L448.318 286.196V274.206H442.742V260.266L448.095 256.808V244.819H440.177V223.796C440.177 220.562 436.274 218.164 431.032 218.164C425.846 218.164 421.887 220.562 421.887 223.796V244.819H415.753V257.087L421.162 260.544V274.262H415.976V286.53L421.385 289.988V322.442H411.57V337.61L418.652 342.127V409.266H445.753V341.848L452.78 337.275V322.442H442.965V289.653ZM425.734 223.796C425.734 223.35 427.63 221.956 431.088 221.956C434.545 221.956 436.441 223.35 436.441 223.796V244.819H425.734V223.796ZM419.6 254.968V248.555H444.359V254.745L439.006 258.202V274.206H425.009V258.425L419.6 254.968ZM419.823 284.411V277.998H444.582V284.188L439.229 287.646V322.386H425.232V287.869L419.823 284.411ZM448.988 335.1L441.961 339.673V405.362H422.444V339.952L415.362 335.435V326.122H448.988V335.1Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.29 281.176C425.29 280.34 424.621 279.727 423.841 279.727C423.004 279.727 422.391 280.396 422.391 281.176V284.355H425.346V281.176H425.29Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.454 281.176C441.454 280.34 440.785 279.727 440.005 279.727C439.168 279.727 438.555 280.396 438.555 281.176V284.355H441.51V281.176H441.454Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.033 281.176C433.033 280.34 432.363 279.727 431.583 279.727C430.802 279.727 430.133 280.396 430.133 281.176V284.355H433.088V281.176H433.033Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.379 347.814C435.379 345.751 433.706 344.078 431.642 344.078C429.579 344.078 427.906 345.751 427.906 347.814V355.956H435.379V347.814Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.126 251.786C425.126 250.949 424.457 250.336 423.676 250.336C422.896 250.336 422.227 251.005 422.227 251.786V254.964H425.182V251.786H425.126Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.236 251.786C441.236 250.949 440.566 250.336 439.786 250.336C438.949 250.336 438.336 251.005 438.336 251.786V254.964H441.291V251.786H441.236Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.822 251.786C432.822 250.949 432.152 250.336 431.372 250.336C430.535 250.336 429.922 251.005 429.922 251.786V254.964H432.877V251.786H432.822Z",
    fill: "#2C52A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.117 392.059V384.312H473.864V392.059H466.117Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.391 392.059V384.312H490.137V392.059H482.391Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.711 392.059V384.312H509.457V392.059H501.711Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.57 392.059V384.312H530.317V392.059H522.57Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.273 392.059V384.312H550.02V392.059H542.273Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.531 384.277L584.531 392.023L576.785 392.023L576.785 384.277L584.531 384.277Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.117 392.059V384.312H473.864V392.059H466.117Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.391 392.059V384.312H490.137V392.059H482.391Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.711 392.059V384.312H509.457V392.059H501.711Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.57 392.059V384.312H530.317V392.059H522.57Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.273 392.059V384.312H550.02V392.059H542.273Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.531 384.277L584.531 392.023L576.785 392.023L576.785 384.277L584.531 384.277Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.258 384.277L568.258 392.023L560.511 392.023L560.511 384.277L568.258 384.277Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.117 358.02V350.273H473.864V358.02H466.117Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.391 358.02V350.273H490.137V358.02H482.391Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.711 358.02V350.273H509.457V358.02H501.711Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.57 358.02V350.273H530.317V358.02H522.57Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.273 358.02V350.273H550.02V358.02H542.273Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.531 350.261L584.531 358.008L576.785 358.008L576.785 350.261L584.531 350.261Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.117 358.02V350.273H473.864V358.02H466.117Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.391 358.02V350.273H490.137V358.02H482.391Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.711 358.02V350.273H509.457V358.02H501.711Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.57 358.02V350.273H530.317V358.02H522.57Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.273 358.02V350.273H550.02V358.02H542.273Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.531 350.261L584.531 358.008L576.785 358.008L576.785 350.261L584.531 350.261Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.258 350.261L568.258 358.008L560.511 358.008L560.511 350.261L568.258 350.261Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.117 374.997V367.25H473.864V374.997H466.117Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.391 374.997V367.25H490.137V374.997H482.391Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.711 374.997V367.25H509.457V374.997H501.711Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.57 374.997V367.25H530.317V374.997H522.57Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.273 374.997V367.25H550.02V374.997H542.273Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.531 367.3L584.531 375.047L576.785 375.047L576.785 367.3L584.531 367.3Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.117 374.997V367.25H473.864V374.997H466.117Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.391 374.997V367.25H490.137V374.997H482.391Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.711 374.997V367.25H509.457V374.997H501.711Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.57 374.997V367.25H530.317V374.997H522.57Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.273 374.997V367.25H550.02V374.997H542.273Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.531 367.3L584.531 375.047L576.785 375.047L576.785 367.3L584.531 367.3Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.258 367.3L568.258 375.047L560.511 375.047L560.511 367.3L568.258 367.3Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.464 197.298L543.463 197.299C541.309 204.981 534.27 210.299 526.296 210.299C518.467 210.299 511.501 205.123 509.278 197.665L509.277 197.661L476.81 89.6778L506.27 172.193C506.27 172.194 506.27 172.194 506.27 172.195C509.288 180.742 517.411 186.433 526.452 186.433C535.741 186.433 543.868 180.569 546.798 171.779L546.799 171.777L571.934 95.9399L543.464 197.298Z",
    fill: "#7E9EE0",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.452 184.933V185.01H526.685C526.53 184.933 526.452 184.933 526.452 184.933ZM526.452 184.933C518.041 184.933 510.488 179.637 507.684 171.694L526.452 184.933ZM506.27 172.195C509.146 180.341 516.66 185.892 525.185 186.395V210.337C517.792 209.849 511.462 204.829 509.276 197.659C509.276 197.658 509.275 197.657 509.275 197.656L476.81 89.6778L506.27 172.193C506.27 172.194 506.27 172.194 506.27 172.195Z",
    fill: "#7E9EE0",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.649 19.6919L592.308 17.7175H590.226H458.854H456.729L457.441 19.72L463.671 37.2415L464.09 38.4209L465.326 38.2194C504.803 31.782 544.745 31.7821 584.144 38.2193L585.405 38.4254L585.809 37.2133L591.649 19.6919ZM584.096 42.3509L584.651 40.68L582.913 40.398C544.362 34.1423 505.265 34.1425 466.638 40.3195L464.856 40.6046L465.463 42.3049L511.17 170.393C511.17 170.396 511.171 170.398 511.172 170.4C513.412 176.854 519.596 181.136 526.37 181.136C533.409 181.136 539.504 176.667 541.731 170.07L541.733 170.063L584.096 42.3509ZM459.177 31.3287L456.264 31.8329V404.378V405.878H457.764H591.239H592.739V404.378V32.9232L589.815 32.4513L543.948 170.829C541.428 178.39 534.372 183.432 526.448 183.432C518.668 183.432 511.685 178.532 509.095 171.194L509.094 171.189L459.177 31.3287ZM594.956 15.5V408.174H453.969V15.5H594.956Z",
    fill: "#3B61AE",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.109 119.34V111.594H473.856V119.34H466.109Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.109 142.387V134.641H473.856V142.387H466.109Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.109 165.364V157.617H473.856V165.364H466.109Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.109 188.418V180.672H473.856V188.418H466.109Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.109 211.387V203.641H473.856V211.387H466.109Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.109 234.434V226.688H473.856V234.434H466.109Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.391 165.372V157.625H490.137V165.372H482.391Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.391 188.418V180.672H490.137V188.418H482.391Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.391 211.395V203.648H490.137V211.395H482.391Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.391 234.442V226.695H490.137V234.442H482.391Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.703 234.442V226.695H509.45V234.442H501.703Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.578 234.442V226.695H530.325V234.442H522.578Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.273 234.442V226.695H550.02V234.442H542.273Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.523 111.605L584.523 119.352L576.777 119.352L576.777 111.605L584.523 111.605Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.523 134.597L584.523 142.344L576.777 142.344L576.777 134.597L584.523 134.597Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.516 157.66L584.516 165.406L576.769 165.406L576.769 157.66L584.516 157.66Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.516 180.652L584.516 188.398L576.769 188.398L576.769 180.652L584.516 180.652Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.516 203.714L584.516 211.461L576.769 211.461L576.769 203.714L584.516 203.714Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.516 226.699L584.516 234.445L576.769 234.445L576.769 226.699L584.516 226.699Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.25 157.66L568.25 165.406L560.503 165.406L560.503 157.66L568.25 157.66Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.25 180.652L568.25 188.398L560.503 188.398L560.503 180.652L568.25 180.652Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.25 203.714L568.25 211.461L560.503 211.461L560.503 203.714L568.25 203.714Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.25 226.699L568.25 234.445L560.503 234.445L560.503 226.699L568.25 226.699Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.109 234.45V226.703H473.856V234.45H466.109Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.383 234.45V226.703H490.129V234.45H482.383Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.703 234.45V226.703H509.45V234.45H501.703Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.562 234.45V226.703H530.309V234.45H522.562Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.266 234.45V226.703H550.012V234.45H542.266Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.523 226.699L584.523 234.445L576.777 234.445L576.777 226.699L584.523 226.699Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.25 226.699L568.25 234.445L560.503 234.445L560.503 226.699L568.25 226.699Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.109 254.301V246.555H473.856V254.301H466.109Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.383 254.301V246.555H490.129V254.301H482.383Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.703 254.301V246.555H509.45V254.301H501.703Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.562 254.301V246.555H530.309V254.301H522.562Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.266 254.301V246.555H550.012V254.301H542.266Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.523 246.535L584.523 254.281L576.777 254.281L576.777 246.535L584.523 246.535Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.109 254.301V246.555H473.856V254.301H466.109Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.383 254.301V246.555H490.129V254.301H482.383Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.703 254.301V246.555H509.45V254.301H501.703Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.562 254.301V246.555H530.309V254.301H522.562Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.266 254.301V246.555H550.012V254.301H542.266Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.523 246.535L584.523 254.281L576.777 254.281L576.777 246.535L584.523 246.535Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.25 246.535L568.25 254.281L560.503 254.281L560.503 246.535L568.25 246.535Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.109 272.981V265.234H473.856V272.981H466.109Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.383 272.981V265.234H490.129V272.981H482.383Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.703 272.981V265.234H509.45V272.981H501.703Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.562 272.981V265.234H530.309V272.981H522.562Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.266 272.981V265.234H550.012V272.981H542.266Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.523 265.207L584.523 272.953L576.777 272.953L576.777 265.207L584.523 265.207Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.109 272.981V265.234H473.856V272.981H466.109Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.383 272.981V265.234H490.129V272.981H482.383Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.703 272.981V265.234H509.45V272.981H501.703Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.562 272.981V265.234H530.309V272.981H522.562Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.266 272.981V265.234H550.012V272.981H542.266Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.523 265.207L584.523 272.953L576.777 272.953L576.777 265.207L584.523 265.207Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.25 265.207L568.25 272.953L560.503 272.953L560.503 265.207L568.25 265.207Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.109 289.965V282.219H473.856V289.965H466.109Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.383 289.965V282.219H490.129V289.965H482.383Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.703 289.965V282.219H509.45V289.965H501.703Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.562 289.965V282.219H530.309V289.965H522.562Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.266 289.965V282.219H550.012V289.965H542.266Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.523 282.254L584.523 290L576.777 290L576.777 282.254L584.523 282.254Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.109 289.965V282.219H473.856V289.965H466.109Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.383 289.965V282.219H490.129V289.965H482.383Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.703 289.965V282.219H509.45V289.965H501.703Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.562 289.965V282.219H530.309V289.965H522.562Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.266 289.965V282.219H550.012V289.965H542.266Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.523 282.254L584.523 290L576.777 290L576.777 282.254L584.523 282.254Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.25 282.254L568.25 290L560.503 290L560.503 282.254L568.25 282.254Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.109 307.012V299.266H473.856V307.012H466.109Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.383 307.012V299.266H490.129V307.012H482.383Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.703 307.012V299.266H509.45V307.012H501.703Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.562 307.012V299.266H530.309V307.012H522.562Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.266 307.012V299.266H550.012V307.012H542.266Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.523 299.214L584.523 306.961L576.777 306.961L576.777 299.214L584.523 299.214Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.109 307.012V299.266H473.856V307.012H466.109Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.383 307.012V299.266H490.129V307.012H482.383Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.703 307.012V299.266H509.45V307.012H501.703Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.562 307.012V299.266H530.309V307.012H522.562Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.266 307.012V299.266H550.012V307.012H542.266Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.523 299.214L584.523 306.961L576.777 306.961L576.777 299.214L584.523 299.214Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.25 299.214L568.25 306.961L560.503 306.961L560.503 299.214L568.25 299.214Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.109 323.997V316.25H473.856V323.997H466.109Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.383 323.997V316.25H490.129V323.997H482.383Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.703 323.997V316.25H509.45V323.997H501.703Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.562 323.997V316.25H530.309V323.997H522.562Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.266 323.997V316.25H550.012V323.997H542.266Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.523 316.261L584.523 324.008L576.777 324.008L576.777 316.261L584.523 316.261Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.109 323.997V316.25H473.856V323.997H466.109Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.383 323.997V316.25H490.129V323.997H482.383Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.703 323.997V316.25H509.45V323.997H501.703Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.562 323.997V316.25H530.309V323.997H522.562Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.266 323.997V316.25H550.012V323.997H542.266Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.523 316.261L584.523 324.008L576.777 324.008L576.777 316.261L584.523 316.261Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.25 316.261L568.25 324.008L560.503 324.008L560.503 316.261L568.25 316.261Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.109 341.043V333.297H473.856V341.043H466.109Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.383 341.043V333.297H490.129V341.043H482.383Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.703 341.043V333.297H509.45V341.043H501.703Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.562 341.043V333.297H530.309V341.043H522.562Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.266 341.043V333.297H550.012V341.043H542.266Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.523 333.222L584.523 340.969L576.777 340.969L576.777 333.222L584.523 333.222Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.109 341.043V333.297H473.856V341.043H466.109Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.383 341.043V333.297H490.129V341.043H482.383Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.703 341.043V333.297H509.45V341.043H501.703Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.562 341.043V333.297H530.309V341.043H522.562Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.266 341.043V333.297H550.012V341.043H542.266Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.523 333.222L584.523 340.969L576.777 340.969L576.777 333.222L584.523 333.222Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.25 333.222L568.25 340.969L560.503 340.969L560.503 333.222L568.25 333.222Z",
    fill: "#0B1D4E",
    stroke: "#3B61AE",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDubai);
export default __webpack_public_path__ + "static/media/DUBAI.38492cc19cba23c55106d1739b4f46fd.svg";
export { ForwardRef as ReactComponent };